import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"
import clsx from "clsx"

const Slider = React.forwardRef(
  ({ className, dotStep = 15000, min = 0, max = 150000, value, ...props }, ref) => {
    const dotCount = Math.floor((max - min) / dotStep)

    return (
      <SliderPrimitive.Root
        ref={ref}
        min={min}
        max={max}
        step={dotStep}
        value={value}
        className={clsx(
          "relative flex w-full touch-none select-none items-center",
          className
        )}
        {...props}
      >
        <SliderPrimitive.Track className="relative h-1 lg:w-[618px] max-lg:w-full max-sm:w-[400px] grow overflow-hidden rounded-full bg-[#D9D9D9]">
          <SliderPrimitive.Range className="absolute h-full bg-[#D4002A]" />
        </SliderPrimitive.Track>

        {/* Dots layer */}
        {Array.from({ length: dotCount + 1 }).map((_, i) => {
          const dotValue = min + i * dotStep
          const percent = ((dotValue - min) / (max - min)) * 100
          const isBehindThumb = value && dotValue <= value[0]

          return (
            <div
              key={dotValue}
              className="absolute top-1/2 h-2 w-2 rounded-full"
              style={{
                left: `${percent}%`,
                transform: "translateX(-50%) translateY(-50%)",
                backgroundColor: isBehindThumb ? "#D4002A" : "#D9D9D9",
              }}
            />
          )
        })}

        <SliderPrimitive.Thumb
          style={{ boxShadow: "0px 6px 13px 0px #0000001F" }}
          className="block border border-[#3C3C432E] h-7 w-7 rounded-full bg-white transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
        />
      </SliderPrimitive.Root>
    )
  }
)

Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }